<template>
    <div>

        <input
            ref="input"
            type="file"
            name="image"
            accept="image/*"
            @change="setImage"
        />

        <div class="uploader-content">
            <section class="cropper-area">
                <div class="img-cropper" :class="isHidden">
                    <vue-cropper
                        ref="cropper"
                        :zoomOnWheel="false"
                        :preview=previewSelector
                        :ready=setData
                        :crop=onCrop
                        :autoCropArea="1"
                        :movable=false
                    />
                </div>

                <div class="actions">
                    <div :class="isHidden">File name: {{ name }}</div>

                    <md-button
                        role="button"
                        @click.prevent="showFileChooser"
                    >
                        Upload image
                    </md-button>

                    <md-button
                        role="button"
                        @click.prevent="removeFile" :class="isHidden"
                    >
                        Remove image
                    </md-button>
                </div>
            </section>
            <section class="preview-area" :class="isHidden">
                <div class="preview" :class="previewClassName"/>
            </section>


        </div>
    </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import {getImageSrc} from "@/js/images";
import _ from 'lodash';
import {uuid} from 'vue-uuid';
import 'cropperjs/dist/cropper.css';

export default {
    name: "image-uploader",
    components: {
        VueCropper,
    },
    mounted() {
        if (this.imgSrc === null) {
            return;
        }

        getImageSrc(this.imgSrc)
            .then((a) => {
                this.$refs.cropper.replace(a);
                this.imgSrc = a;
            });
    },
    computed: {
        isHidden: function () {
            return {
                hidden: this.imgSrc == null
            }
        }
    },
    props: {
        value: Object
    },

    data() {
        let previewClassName = 'preview-' + uuid.v4()
        let imgSrc = null;
        let name = '';
        if (this.value) {
            if (this.value.source) {
                imgSrc = process.env.VUE_APP_API_URL + '/api/v1/hierarchy/files/' + this.value.source;
            }
            if (this.value.name && this.value.name.length){
                name = this.value.name;
            }
        }

        return {
            imgSrc: imgSrc,
            isLoading: true,
            data: '',
            name: name,
            previewClassName: previewClassName,
            previewSelector: "." + previewClassName,
            source: this.value.source,
            target: this.value.target,
        };
    },
    methods: {
        onCrop: _.debounce(function (e) {
            if (e === null)
                return;

            this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
                this.data = e.detail;
                this.targetFile = blob;
                this.triggerTargetChanged();
            });

        }, 200),
        getArgs: function () {
            return {
                data: this.data,
                name: this.name,
                source: this.source,
                target: this.target,
                sourceFile: this.sourceFile,
                targetFile: this.targetFile,
            };
        },
        triggerTargetChanged() {
            this.$emit('targetChanged', this.getArgs())
        },
        triggerSourceChanged() {
            this.$emit('sourceChanged', this.getArgs())
        },
        reset() {
            this.$refs.cropper.reset();
        },
        setData() {
            this.isLoading = false;
            if(this.value) {
                if (this.value.data !== null) {
                    this.$refs.cropper.setData(this.value.data);
                } else {
                    this.$refs.cropper.setData({width: 999999, height: 999999, x: 0, y: 0});
                }
            }
        },
        setImage(e) {
            const file = e.target.files[0];

            this.name = file.name;

            if (file.type.indexOf('image/') === -1) {
                alert(this.$t('Please select an image file'));
                return;
            }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.imgSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.setData({width: null, height: null, x: null, y: null});
                    this.$refs.cropper.replace(event.target.result);
                };

                this.sourceFile = file;
                this.source = null;
                this.target = null;
                reader.readAsDataURL(file);

                this.triggerSourceChanged();
            } else {
                alert(this.$t('Sorry, FileReader API not supported'));
            }
        },
        removeFile() {
            this.imgSrc = null;
            this.sourceFile = null;
            this.targetFile = null;
            this.source = null;
            this.target = null;
            this.$refs.cropper.replace("xxx");
            this.triggerSourceChanged();
        },
        showFileChooser() {
            this.$refs.input.click();
        },
    },
    watch: {
        value: {
            handler: function (val) {
                if (val) {
                    this.data = val.data;
                    this.name = val.name
                }
            },
            deep: true
        }
    }
};
</script>

<style scoped>

input[type="file"] {
    display: none;
}

.hidden {
    display: none;
}

.uploader-content {
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;
}

.cropper-area {
    width: 614px;
}

.actions {
    margin-top: 1rem;
}

.actions a {
    display: inline-block;
    padding: 5px 15px;
    background: #0062CC;
    color: white;
    text-decoration: none;
    border-radius: 3px;
    margin-right: 1rem;
    margin-bottom: 1rem;
}

.preview-area {
    width: 307px;
}

.preview-area p {
    font-size: 1.25rem;
    margin: 0;
    margin-bottom: 1rem;
}

.preview-area p:last-of-type {
    margin-top: 1rem;
}

.preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
}

.cropped-image img {
    max-width: 100%;
}
</style>
